import React, { useState } from "react";

// MUI
import Grid from "@mui/material/Grid";

// Components
import {
  SBGFilter,
  SBUFilter,
  BDHeadFilter,
  BDPOCFilter,
} from "./filter-bar-section/FilterBarSection";
import CustomDatePicker from "../DatePicker";
import SortingSection from "./sort-bar-section/SortingSection";
import {
  IFilterProjectModel,
  ProjectsSortOptionsModel,
} from "../../models/ProjectResponseModel";
import PageSearch from "../../admin/PageSearch";
import { ComponentName } from "../../SectionWiseClassification";
import BidListSection from "./bid-list-section/BidListSection";

export interface DashboardFiltersProps {
  roleId: number;
  filters: {
    search: string;
    sbuHead: string;
    bdHead: string;
    sbgHead: string;
    bdPoc: string;
  };
  handleFilters: (key: string, value: string) => void;
  fromDate: Date;
  endDate: Date;
  handleFromDate: (date: Date | null) => void;
  handleEndDate: (date: Date | null) => void;
  statusChangeHandler: (val: string) => void;
  statusFilters: ProjectsSortOptionsModel[];
  statusValue: string;
  onChange: (key: string, value: string) => void;
  currentComponent?: string;
  isFiltered: boolean;
  resetFlags: () => void;
  projects: IFilterProjectModel[];
  scrollToTopOnBidSelection: () => void;
  handleDrawerToggle?: () => void;
  selected?: boolean;
}

const DashboardFilters = ({
  roleId,
  filters,
  handleFilters,
  fromDate,
  endDate,
  handleFromDate,
  handleEndDate,
  statusValue,
  statusFilters,
  statusChangeHandler,
  onChange,
  currentComponent,
  isFiltered,
  resetFlags,
  projects,
  scrollToTopOnBidSelection,
  handleDrawerToggle,
}: DashboardFiltersProps) => {
  const [selectedSbg, setSelectedSbg] = useState<string>();

  const handleSearchChange = (val: string) => {
    onChange("search", val);
  };

  const onChangeSbgValue = (value: string) => {
    setSelectedSbg(value);
  };

  return (
    <Grid container spacing={{ xs: 1, md: 2 }} alignItems="center" pb={1}>
      {currentComponent === ComponentName.BidDetails && (
        <Grid item xs={12} md={2}>
          <PageSearch
            placeholder="Search project name"
            searchHandler={handleSearchChange}
            disableMb={true}
          />
        </Grid>
      )}
      {roleId !== 1 && roleId !== 2 && (
        <Grid
          item
          xs={12}
          md={currentComponent !== ComponentName.BidDetails ? 2 : 1.5}
        >
          <SBGFilter
            value={filters.sbgHead}
            onChange={handleFilters}
            onChangeSbgValue={onChangeSbgValue}
          />
        </Grid>
      )}
      {roleId !== 1 && roleId !== 2 && roleId !== 3 && (
        <Grid
          item
          xs={12}
          md={currentComponent !== ComponentName.BidDetails ? 2 : 1}
        >
          <SBUFilter
            value={filters.sbuHead}
            onChange={handleFilters}
            selectedSbg={selectedSbg}
          />
        </Grid>
      )}
      {roleId !== 1 && roleId !== 2 && (
        <Grid
          item
          xs={12}
          md={currentComponent !== ComponentName.BidDetails ? 2 : 1.5}
        >
          <BDHeadFilter value={filters.bdHead} onChange={handleFilters} />
        </Grid>
      )}
      {roleId !== 1 && (
        <Grid
          item
          xs={12}
          md={currentComponent !== ComponentName.BidDetails ? 2 : 1.5}
        >
          <BDPOCFilter value={filters.bdPoc} onChange={handleFilters} />
        </Grid>
      )}
      {currentComponent === ComponentName.BidDetails && (
        <Grid item xs={12} md={1.5}>
          <SortingSection
            filters={statusFilters}
            value={statusValue}
            onChange={statusChangeHandler}
          />
        </Grid>
      )}

      <>
        <Grid
          item
          xs={12}
          md={currentComponent !== ComponentName.BidDetails ? 2 : 1.5}
        >
          <CustomDatePicker
            label="From Date"
            placeholderText="From Date"
            selected={fromDate}
            onChange={handleFromDate}
            maxDate={endDate}
            info={"Bid Submission Date"}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={currentComponent !== ComponentName.BidDetails ? 2 : 1.5}
        >
          <CustomDatePicker
            label="End Date"
            placeholderText="End Date"
            selected={endDate}
            onChange={handleEndDate}
            minDate={fromDate}
            info={"Bid Submission Date"}
          />
        </Grid>
      </>

      {currentComponent === ComponentName.BidDetails && (
        <Grid
          item
          flex={1}
          sx={{ overflowY: "auto", display: { md: "none", xs: "block" } }}
        >
          <BidListSection
            isFiltered={isFiltered}
            resetFlags={resetFlags}
            projects={projects}
            scrollToTopOnBidSelection={scrollToTopOnBidSelection}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default DashboardFilters;
